/* 30/10/2026: mega menu brand strip (snippets/eden-header-mega.liquid). One row that never wraps; when a
   category has more brands than fit, the row scrolls sideways and the arrows page it. Keyboard users tab
   through the logos (focus scrolls each into view), so the arrows are mouse only. A panel opening resizes
   its track from 0, which the observer catches. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-eh-brands]').forEach((strip) => {
      const track = strip.querySelector('.eh-mega__brands-track');
      if (!track || strip.dataset.ehBrandsReady) return;
      strip.dataset.ehBrandsReady = '1';
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        strip.classList.toggle('is-scrollable', max > 1);
        strip.classList.toggle('is-start', track.scrollLeft <= 1);
        strip.classList.toggle('is-end', track.scrollLeft >= max - 1);
      };
      track.addEventListener('scroll', sync, { passive: true });
      strip.querySelectorAll('[data-eh-brands-step]').forEach((button) =>
        button.addEventListener('click', () => {
          const step = Number(button.dataset.ehBrandsStep) * Math.max(track.clientWidth * 0.8, 120);
          track.scrollBy({ left: step, behavior: reduce.matches ? 'auto' : 'smooth' });
        })
      );
      if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
